<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Claim-Pets-Manage",
  path: "manage",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
